import React, { useEffect, useState } from "react";
import styles from "../../Style/Managebutton.module.css";
import apiServices from "../../../../services/apiServices";
import AddIconButton from "./AddIcon";
import { getSocket } from "../../../../services/socketService";
import { useDispatch, useSelector } from "react-redux";
import StatusBadge from "../StatusBadge";
import { setSnackbarAction } from "../../../../Store/Buzzcom/actions";

function AddFriend({
  setSnackbarState,
  setPopupAdd,
  selectedChat,
  setAddedContactIds,
  acceptAddContact,
  memoizedUserIdsArray,
}) {
  // STATES
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [contactDelete, setContactDelete] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [userName, setUserName] = useState(null);
  const [userId, setUserId] = useState(null);
  const [clickedContact, setClickedContact] = useState(null);
  const contactToAdd = useSelector((state) => state.Buzzcom.contactToAdd);
  const socket = getSocket();
  const [queryResultUpdate, setQueryResultUpdate] = useState(null);

  // HOOKS TO MAKEUP COMPONENT
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("user"));
        console.log("userid...", userData);

        // let response = await apiServices.getUserById(userData.result.users.id);

        // Update state with user data
        setUserId(userData?.id);
        setUserName(userData?.firstName + " " + userData?.lastName);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchData();
    return () => {
      // Optional cleanup
    };
  }, []);

  // METHODS

  const handleSearchQueryChange = async (e) => {
    const query = e.target.value;

    setSearchQuery(query);

    const trimmedQuery = query.replace(/^\s+/, ""); // Trim leading spaces

    if (trimmedQuery === "") {
      setSearchResults([]); // Clear search results if input is empty or contains only whitespace after trimming
      return;
    }

    // Call the search function and update searchResults
    const results = await apiServices.search(trimmedQuery, userId);
    console.log("results", results?.data);
    setSearchResults(results?.data);
  };

  const clearQuery = () => {
    setSearchQuery("");
    setSearchResults([]);
  };

  const handleAddContact = async (contact) => {
    setPopupAdd(false);
    let obj = {
      contacts: [
        {
          userId: userId,
          name: userName,
          userName: userName,
        },
        {
          userId: contact?.userId,
          name: contact?.name,
          userName: contact?.userName,
        },
      ],
      requestedBy: userId,
    };

    let response = await apiServices.createContact(obj);

    if (response?.error == 409) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: response?.response?.data?.error,
      });
      // alert(response?.response?.data?.error);
    } else if (response?.response?.status == 500) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: response?.response?.data?.error,
      });
      // alert(response?.response?.data?.message);
    } else if (response?.response?.data?.error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: response?.response?.data?.error,
      });
      // alert(response?.response?.data?.message);
    } else if (
      response?.message == "Contact Stored Successfully" ||
      response?.error == false
    ) {
      socket.emit("new-contact-request", {
        from: userId,
        to: contactDelete?.userId,
        type: "newContact",
      });
      setQueryResultUpdate(!queryResultUpdate);
      dispatch(
        setSnackbarAction({
          show: true,
          status: "success",
          message: response?.message || "Contact Added",
        })
      );
      const newContactId = contact?.userId;
      setAddedContactIds((prevIds) => [...prevIds, newContactId]);
    }
    console.log("response", response);
  };

  // const handleDeleteContact = async (message) => {
  //   let obj = {
  //     requestedBy: message?.requestedBy,
  //     conversationId: message?.conversationId,
  //   };

  //   if (addedContactIds.includes(message.contacts[1].userId)) {
  //     const updatedContactIds = addedContactIds.filter(
  //       (id) => id !== message.contacts[1].userId
  //     );
  //     setAddedContactIds(updatedContactIds);
  //   }
  //   if (message?.conversationId == selectedChat?.conversationId) {
  //     setTimeout(() => {
  //       setSelectedChat(null);
  //     }, 1000);
  //   }
  //   let response = await apiServices.deleteContact(obj);
  //   if (response?.response?.status == 404) {
  //     // alert(response?.response?.data?.message);
  //   } else {
  //     setPopUpBlockDelete(false);
  //     setOpen(false);
  //     // alert(response?.message);
  //     // getContacts();
  //   }
  // };

  // HOOKS

  useEffect(
    () => {
      if (contactToAdd) handleAddContact(contactToAdd);
    },
    { contactToAdd }
  );

  useEffect(() => {
    const fetchSearchResults = async () => {
      const trimmedQuery = searchQuery.trim();

      if (trimmedQuery === "") {
        setSearchResults([]); // Clear search results if input is empty or contains only whitespace after trimming
        return;
      }

      try {
        // Call the search function and update searchResults
        const results = await apiServices.search(trimmedQuery, userId);
        // setSearchCall(false); // Replace 'userId' with the actual userId
        setSearchResults(results?.data);
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    };

    fetchSearchResults();
    return () => {};
  }, [searchQuery, queryResultUpdate]);

  useEffect(() => {
    if (clickedContact) {
      handleAddContact(clickedContact);
    }
  }, [acceptAddContact]);

  console.log("clickedContact", clickedContact, acceptAddContact, contactToAdd);

  return (
    <div
      className={`${styles.AddFriend} d-flex flex-column position-relative `}
    >
      <div
        className="input-group mb-3 position-relative"
        style={{ width: "100%" }}
      >
        {/* Left Icon */}
        <span
          style={{
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "18px",
            color: "#ffffff",
            zIndex: 2,
            border: "none",
          }}
        >
          <img src="/BuzzCom/images/search-logo.png" alt="search" />{" "}
          {/* Replace this with a search icon */}
        </span>
        {/* Input Field */}
        <input
          type="text"
          className="form-control"
          placeholder={searchQuery ? "" : "Search Contacts"}
          aria-label="Search Contacts"
          value={searchQuery}
          onChange={handleSearchQueryChange}
          style={{
            paddingLeft: "35px", // For spacing due to the search icon
            paddingRight: "35px", // For spacing due to the clear icon
            color: "grey",
            fontSize: "14px",
            border: "1px solid #dcdcdc",
            borderRadius: "10px", // Rounded edges
            height: "40px", // Match the design height
            zIndex: 1,
          }}
        />

        {/* Right Clear Icon */}
        <span
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "18px",
            cursor: "pointer",
            color: "#b0b0b0",
            zIndex: 2,
            border: "none",
          }}
          onClick={clearQuery}
        >
          <img
            src="/BuzzCom/images/close.svg"
            alt="close"
            className=""
            style={{ opacity: 11 }}
          />{" "}
          {/* Replace this with a close icon */}
        </span>
      </div>
      <div className={styles.SearchList}>
        {searchQuery !== "" &&
          (searchResults?.length > 0 ? (
            searchResults
              .sort((a, b) => (a.userName > b.userName ? 1 : -1))
              .map((searchedContact, index) => (
                <div
                  key={searchedContact._id}
                  className={`${styles.addfriendlistitem} ${
                    selectedChat &&
                    selectedChat._id === searchedContact._id &&
                    "bg-light border-primary"
                  }`}
                >
                  <div className="gap-2 mx-4 borderRadius-2">
                    <StatusBadge
                      contact={searchedContact}
                      memoizedUserIdsArray={memoizedUserIdsArray}
                    />
                  </div>
                  <div className="flex-grow-1 d-flex align-items-center pt-3">
                    <p
                      style={{
                        position: "relative",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "black",
                        fontFamily: "Roboto",
                        flexBasis: "",
                      }}
                    >
                      {searchedContact?.userName}
                    </p>
                  </div>
                  <div className="me-4">
                    {searchedContact.status === "default" ||
                    searchedContact.status === "decline" ||
                    searchedContact.status === "cancelled" ? (
                      <AddIconButton
                        setClickedContact={setClickedContact}
                        setPopupAdd={setPopupAdd}
                        message={searchedContact}
                        handleAddContact={handleAddContact}
                      />
                    ) : (
                      <p
                        style={{
                          fontSize: "10px",
                          textTransform: "capitalize",
                        }}
                        className="m-0"
                      >
                        {searchedContact.status}
                      </p>
                    )}
                  </div>
                  {/* <hr className="my-2" style={{ borderColor: "#e4e4e4" }} /> */}
                </div>
              ))
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{}}
            >
              <h6 className="text-muted">No Contacts Matched</h6>
            </div>
          ))}
      </div>
    </div>
  );
}

export default AddFriend;
